import React from "react";
import { Title } from "../../utils/types";

// Shows the title with an underline if the title is not empty
export const ArbeitsplanTitleWithUnderline = ({ title }: { title: string }) => {
  if (!title) {
    return null;
  }
  return (
    <>
      <Title className="ArbeitsplanTitle" style={{ wordBreak: "break-word" }}>
        {title}
      </Title>
      <hr
        style={{
          width: "100%",
          height: "2px",
          backgroundColor: "black",
          margin: "10px 0",
        }}
      />
    </>
  );
};
